import LevelBase from "./levelBase";
import { Enemy, Exit, Player } from "../objects";
import { Interactive } from "../objects";
import { translate } from "../../utils/localization";

class Level4 extends LevelBase {
  constructor() {
    super();
    this.name = "The round";
    this.enemiesCount = 0;
    // countdown to trigger dialog after n moves after the quake
    this.countDownAfterQuakeUntilMessage = null;

    // this.onPlayerMoves.bind(this)
  }

  get id() {
    return this.constructor.key;
  }

  async onInteractWith(el) {
    super.onInteractWith(el);

    // earthquake triggers
    if ([0, 1, 2, 3, 4, 5, 6, 7].includes(el.order)) {
      this.player.disconnect();
      await this.playEarthquake(
        {
          x1: el.position.x - 9,
          x2: el.position.x + 9,
          y1: el.position.y - 6,
          y2: el.position.y + 6,
        },
        1
      );

      if (this.unfinished) {
        this.countDownAfterQuakeUntilMessage = 4;
        this.scene.events.addListener("player_moves", this.onPlayerMoves, this);
      }
      this.player.reconnect();
    }

    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }
  onPlayerMoves() {
    if (this.countDownAfterQuakeUntilMessage !== null) {
      this.countDownAfterQuakeUntilMessage--;
      if (this.countDownAfterQuakeUntilMessage === 0) {
        this.showDialog1();

        this.scene.events.removeListener("player_moves", this.onPlayerMove);
      }
    }
  }

  showDialog1() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ["Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_4.dialog_1.mary_say_1")],
        },
      ],
    });
  }
  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

    if (el.isClass(Enemy)) {
      this.enemiesCount++;
      // make second enemy to run ACW so boulder can make it escape from blast
      if (this.enemiesCount % 2 === 0) {
        el.scanDirection = "ACW";
      }
    }
  }
}

Level4.key = "level_4";
export default Level4;
